import SimulatorLineup from "../components/simulatorLineup/simulatorLineup";
import { lineupARGConfig } from "../components/simulatorLineup/configs/lineupARG.config";

export default function SimulatorLineupARGPage() {
  return (
    <div className="simulador-page">
      <SimulatorLineup config={lineupARGConfig} />
    </div>
  );
}
